export const RACE_STATUS_LIST = ['Open', 'Closed', 'Post', 'Final', 'Canceled'];
export const TRACK_TYPE_lIST = ['JaiAlai', 'Thoroughbred', 'Greyhound', 'Quarterhorse', 'Harness', 'Arabian', 'Mixed', 'Cycle', 'Boat', 'Vehicle', 'Sports', 'Other', 'Unknown'];
export const POOL_LIST = ['WIN', 'PLC', 'SHW', 'EX', 'QU', 'TRI', 'TRL', 'SPR', 'PEN', 'HEX', 'DBL', 'PK3', 'PK4', 'PK5', 'PK6', 'PK7', 'PK8', 'PK9', 'PK10', 'PK11', 'PK12', 'QD', 'DQ', 'TT', 'TS'];
export const POOL_LIST_NAME = {
  'WIN' : 'WIN',
  'DBL' : 'DOUBLE',
  'EX'  : 'EXACTA',
  'QU'  : 'QUINELLA',
  'TRL' : 'TRIO',
  'OMN' : 'Omni',
  'SHW' : 'SHOW',
  'TRI' : 'TRIFECTA',
  'SPR' : 'SUPERFECTA',
  'PLC' : 'PLACE',
  'WP' : 'WIN-PLC',
  'WPS' : 'WIN-PLC-SHW',
  'PK3' : 'Pick-3',
  'PK5' : 'Pick-5',
  'PK6' : 'Pick-6',
  'PK7' : 'Pick-7',
  'PK8' : 'Pick-8',
  'PK9' : 'Pick-9',
  'PK10' : 'Pick-10',
  'PK11' : 'Pick-11',
  'PK12' : 'Pick-12'
};
export const POOL_LIST_ID = [
  "WIN",
  "PLC",
  "SHW",
  "WP",
  "WPS",
  "PS",
  "EX",
  "QU",
  "TRL",
  "TRI",
  "SPR",
  "PEN",
  "HEX",
  "OMN",
  "DBL",
  "PK3",
  "PK4",
  "PK5",
  "PK6",
  "PK7",
  "PK8",
  "PK9",
  "PK10",
  "PK11",
  "PK12",
  "TR2",
  "SP2",
  "TS"
];


export const TRACK_COLOR: any = {
  Thoroughbred: {
    1: 'red',
    2: 'white',
    3: 'blue',
    4: 'yellow',
    5: 'green',
    6: 'black',
    7: 'orange',
    8: 'pink',
    9: 'turquoise',
    10: 'purple',
    11: 'gray',
    12: 'lime',
    13: 'brown',
    14: 'maroon',
    15: 'khaki',
    16: 'lightblue',
    17: 'navy',
    18: 'darkgreen',
    19: '#73A9C2',
    20: 'fuchsia',
    21: 'red',
    22: 'white',
    23: 'blue',
    24: 'yellow',
    25: 'green',
    26: 'black',
    27: 'orange',
    28: 'pink',
    29: 'turquoise',
    30:  'purple'
  },
  Quarterhorse: {
    1: 'red',
    2: 'white',
    3: 'blue',
    4: 'yellow',
    5: 'green',
    6: 'black',
    7: 'orange',
    8: 'pink',
    9: 'turquoise',
    10: 'purple',
    11: 'gray',
    12: 'lime',
    13: 'brown',
    14: 'maroon',
    15: 'khaki',
    16: 'lightblue',
    17: 'navy',
    18: 'darkgreen',
    19: '#73A9C2',
    20: 'fuchsia',
    21: 'red',
    22: 'white',
    23: 'blue',
    24: 'yellow',
    25: 'green',
    26: 'black',
    27: 'orange',
    28: 'pink',
    29: 'turquoise',
    30:  'purple'
  },
  Harness: {
    1: 'red',
    2: 'blue',
    3: 'white',
    4: 'green',
    5: 'black',
    6: 'yellow',
    7: 'pink',
    8: 'gray',
    9: 'purple',
    10: 'lightblue',
    11: 'lightgreen',
    12: 'lightyellow',
    13: 'lightgray',
    14: 'darkgray',
    15: 'red',
    16: 'blue',
    17: 'white',
    18: 'green',
    19: 'black',
    20: 'yellow',
    21: 'pink',
    22: 'gray',
    23: 'purple',
    24: 'lightblue',
    25: 'lightgreen',
    26: 'lightyellow',
    27: 'lightgray',
    28: 'darkgray',
  },
  Greyhound: {
    1: 'red',
    2: 'blue',
    3: 'white',
    4: 'green',
    5: 'black',
    6: 'yellow',
    7: 'lightgreen',
    8: 'darkgray',
    9: 'purple',
    10: 'red',
    11: 'blue',
    12: 'white',
    13: 'green',
    14: 'black',
    15: 'yellow',
    16: 'lightgreen',
    17: 'darkgray',
    18: 'purple',
  }
}

export const MODIFIER_NICK_NAME = {
  'Straight': '', 'Wheel': 'WH', 'Box': 'BX', 'PowerBox': 'PB', 'KeyBox': 'KB',
  'KeyWheel': 'KW', 'Leading': 'LD', 'DutchCost': 'DC', 'DutchPayout': 'DP','ABC': 'ABC'
};

export const HORSE_BREED = {
  0: 'All',
  1: 'Quarterhorse',
  2: 'Greyhound',
  3: 'Harness',
  4: 'Thoroughbred'
};
